import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { QuestionnaireService } from "app/services/questionnaire.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "app/services/helper.service";
import { ActivatedRoute } from "@angular/router";
import { TosterMessageService } from "app/services/toster-message.service";
import { QuestionBankService } from "../../services/question-bank.service";
@Component({
  selector: "app-question-bank-edit-view-modal.component",
  templateUrl: "./question-bank-edit-view-modal.component.html",
  styleUrls: ["./question-bank-edit-view-modal.component.scss"],
  providers: [QuestionBankService],
})
export class QuestionBankEditViewModalComponent implements OnInit {
  public masterData: any = {};
  public countries: any = {};
  public gradeArr: any = [];
  public designationCategories: any = [];
  public trainingProgramCategories: any = [];
  public departments: any = [];
  validateForm: FormGroup;

  id: number;
  header_id_2: number;
  currentTutorial = null;
  message = "";

  formData = {
    media_type: "",
    media_link: "",
    storage_siz: "",
    answer: "",
    header_id: "",
    header_detail_id: "",
  };

  questionHeader: any = {
    question: "",
    sort: "",
    marks: "",
  };

  @Input() auto_id: number;

  isEdit: number;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("f") form: any;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = this.helperService.getSelectedCompanyId();
  header_id = 1;
  header_detail_id = 1;

  activeStatus = [
    { value: 1, label: "Active" },
    { value: 0, label: "Not Active" },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private questionBankService: QuestionBankService
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
    this.validateForm = this.formBuilder.group({
      sort: [{ value: "" }, [Validators.required]],
      question: [{ value: "" }, [Validators.required]],
      marks: [{ value: "" }, [Validators.required]],
    });

    this.auto_id = Number(localStorage.getItem("question-bank-edit-auto-id"));
    this.header_id_2 = Number(
      localStorage.getItem("question-bank-edit-header-id")
    );
    localStorage.removeItem("question-bank-edit-auto-id");
    localStorage.removeItem("question-bank-edit-header-id");
    this.getQuestionHeader(this.header_id_2);
  }

  getQuestionHeader(header_id_2: number) {
    console.log(this.header_id_2);
    this.questionBankService
      .getQuestionBankHeader(this.header_id_2)
      .get()
      .subscribe((resp) => {
        const data = resp.data.data;
        console.log(data);
        this.questionHeader = data;

        this.validateForm.get("sort").setValue(data.sort);
        this.validateForm.get("question").setValue(data.question);
        this.validateForm.get("marks").setValue(data.marks);
      });
  }

  updateHeader() {
    console.log(this.header_id_2);
    const requestData = {
      sort: this.validateForm.get("sort").value,
      question: this.validateForm.get("question").value,
      marks: this.validateForm.get("marks").value,
      header_id: this.header_id_2,
    };
    console.log(requestData);
    let that = this;
    this.questionBankService
      .updateQuestionBankHeader(this.header_id_2)
      .customPUT(requestData)
      .subscribe(
        (resp: any) => {
          console.log(resp);
          this.successMsg = "Successfully updated question header";
          this.showSuccessHtml();
          this.closeModalAfterCreate();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
    this.tableReload.emit();
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-edit-view-modal/question-bank-edit-view-modal.component.ts